const initialState = {
  finalState: null,
};

const finalStateReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_FINAL_STATE':
      return {
        ...state,
        finalState: action.payload,
      };
    default:
      return state;
  }
};

export default finalStateReducer;